module.exports = __webpack_public_path__ + "img/tipShare-logo.22855709.png";